export default {
  primFont: 'proxima-nova, sans-serif',
  secFont: '"Roboto Slab", sans-serif',

  primOrange: '#F2783E',
  primBlack: '#000000',
  primBlue: '#005596',
  secBlue: '#000478',
  secWhite: '#F2F2F2',
  secYellow: '#FFC02E',
  tertMintGreen: '#2FBEA3',
  tertGreen: '#6F9A1A',
  tertBlue: '#234C6A',

  darkgray: '#9DA1A8',
  gray: '#DBDBDB',
  lightgray: '#F7F7F7',

  countryEnabled: 'rgba(255, 255, 255, 0.15)',
  countryDisabled: 'rgba(255, 255, 255, 0.075)',
  background: '#FFFFFF',

  faintBlue: '#0055962F'
};
